
import "./styles.css";
import { createRoot } from 'react-dom/client';
import App from "./App";

import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import 'regenerator-runtime/runtime'
import createSagaMiddleware from "redux-saga";

import rootReducer from "./rootReducer";
import rootSaga from "./sagas";

//const sagaMiddleWare = createSagaMiddleware();
//const store = createStore(rootReducer, {}, applyMiddleware(sagaMiddleWare));
const store = createStore(rootReducer);
//sagaMiddleWare.run(rootSaga);

const rootElement = document.getElementById("root");
createRoot(rootElement).render(
  <Provider store={store}>
    <App />
  </Provider>
);
